module.exports = __webpack_public_path__ + "static/media/placeholderAd1.63d09348.mp4";